import { Box } from '@mui/material';
import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';

import GameService from '../../../../../services/game.service';
import { gameCreateCommand } from '../../../components/utilities';
import { XmlDataFilterGame } from '../../../components/xmldata';
import { ActionData, TagToActionData, normalizeTagData, isGoalTag } from '../../../components/common';
import GameTagButtonList from './tagButtonList';
import { TAG_KEYS } from './tagKeys';
import GameTagMenu from './tagMenu';
import GameExportToEdits from './exportEdits';
import SharedVideoPlayer from '../../../components/SharedVideoPlayer';
import { getPeriod } from './tagListItem';
import Alert from '../../../../../common/alert';

const GameOverview = ({ game, t }) => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [showAlert, setShowAlert] = useState(false);
    const [showResultAlert, setShowResultAlert] = useState(false);
    const [downState, setDownState] = useState('');
    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);
    useEffect(() => {
        if (showResultAlert) {
            const timer = setTimeout(() => {
                setShowResultAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showResultAlert]);

    const [curTeamTagIdx, setCurTeamTagIdx] = useState(0);
    const [videoData, setVideoData] = useReducer((old, action) => ({ ...old, ...action }), {
        idx: 0,
        autoPlay: true,
        tagList: [],
        videoPlay: true,
        click: false
    });
    const [values, setValues] = useState({
        isOur: true,
        expandButtons: true,
        playList: [],
        teamId: -1,
        opponentTeamId: -1,
        selectAll: false,
        clickEventName: ''
    });
    // tagIndex stays the DISPATCH key so the branches below keep matching.
    // tagLabel is the button's identity, which is what marks it selected;
    // tagSide fixes the perspective for buttons that carry one.
    const [tagLabel, setTagLabel] = useState('');
    const [tagSide, setTagSide] = useState(null);
    const [tagIndex, setTagIndex] = useState('');
    const [loadData, setLoadData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkArray, setCheckArray] = useState([]);
    const [exportHudl, setExportHudl] = useState(false);
    const [playerTagList, setPlayerTagList] = useState([]);
    const [exportEditOpen, setExportEditOpen] = useState(false);
    const [exportList, setExportList] = useState([]);
    const [videoPlayerOpen, setVideoPlayerOpen] = useState(false);
    const [gameTime, setGameTime] = useState({
        period: 'H1',
        time: 0,
        video_url: '',
        home_team_goals: 0,
        away_team_goals: 0,
        home_team_image: game.home_team_image,
        away_team_image: game.away_team_image
    });

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    const handleChangeTeam = (flag) => {
        setValues({ ...values, isOur: flag, playList: [] });
        setVideoData({ ...videoData, idx: 0, tagList: [] });
        setTagIndex('');
    };

    const handleShowPopover = (button) => (e) => {
        const idx = button.tag;

        setTagLabel(button.label);
        setTagSide(button.side ?? null);
        setTagIndex(idx);
        setGameTime({ ...gameTime, period: 'H1', time: 0, home_team_goals: 0, away_team_goals: 0, home_team_image: '', away_team_image: '' });
        setMenuAnchorEl(e.currentTarget);
    };

    const handleClickView = () => {
        setMenuAnchorEl(null);
        setLoading(true);
        setValues({ ...values, clickEventName: '' });
        setLoadData(true);
    };

    const handleClickHudlFromButton = () => {
        const newList = values.playList.filter((item, index) => checkArray[index] === true);

        setPlayerTagList(newList);
        setExportHudl(true);
    };

    const handleClickHudlFromMenu = () => {
        setMenuAnchorEl(null);

        if (values.playList.length === 0) {
            setLoading(true);
            setValues({ ...values, clickEventName: 'sportcode' });
            setLoadData(true);
        } else {
            setPlayerTagList(values.playList);
            setExportHudl(true);
        }
    };

    const handleClickRenderFromMenu = async () => {
        setMenuAnchorEl(null);

        if (values.playList.length === 0) {
            setValues({ ...values, clickEventName: 'render' });
            setLoadData(true);
        } else {
            setShowAlert(true);
            const result = await gameCreateCommand(values.playList, tagIndex, [game], [game.id]);

            setShowResultAlert(true);
            setDownState(result);
        }
    };

    const handleClickRenderFromButton = async () => {
        const newList = values.playList.filter((item, index) => checkArray[index] === true);
        setShowAlert(true);
        const result = await gameCreateCommand(newList, tagIndex, [game], [game.id]);

        setShowResultAlert(true);
        setDownState(result);
    };

    const handleClickEditFromMenu = () => {
        setMenuAnchorEl(null);

        if (values.playList.length > 0) {
            setExportList(values.playList);
            setExportEditOpen(true);
        } else {
            setLoading(true);
            setValues({ ...values, clickEventName: 'my_edits' });
            setLoadData(true);
        }
    };

    const handleClickEditFromButton = () => {
        const newList = values.playList.filter((item, index) => checkArray[index] === true);

        setExportList(newList);
        setExportEditOpen(true);
    };

    const handleExpandButtons = () => {
        setValues({ ...values, expandButtons: !values.expandButtons });
    };

    const handleShowVideo = (index) => {
        setCurTeamTagIdx(index);
        setVideoData({ ...videoData, idx: index, click: !videoData.click });
        setVideoPlayerOpen(true);
    };

    const handleCheckChange = (idx) => (e) => {
        setCheckArray({ ...checkArray, [idx]: e.target.checked });
    };

    const getTime = (time, delta) => {
        const items = time.split(':');
        const changedTime = parseInt(items[0]) * 3600 + parseInt(items[1]) * 60 + parseInt(items[2]) + delta;
        let hour = Math.floor(changedTime / 3600);
        let minute = Math.floor((changedTime - hour * 3600) / 60);
        let second = changedTime - hour * 3600 - minute * 60;

        if (hour < 10) hour = '0' + hour;
        if (minute < 10) minute = '0' + minute;
        if (second < 10) second = '0' + second;

        return hour + ':' + minute + ':' + second;
    };

    const handleChangeTime = (index, isStart, direction) => {
        let array = [...values.playList];
        let data = [...videoData.tagList];

        // Handle both team_tag and player_tag fields
        const startTimeKey = array[index].team_tag_start_time !== undefined ? 'team_tag_start_time' : 'player_tag_start_time';
        const endTimeKey = array[index].team_tag_end_time !== undefined ? 'team_tag_end_time' : 'player_tag_end_time';

        if (isStart) {
            const changed = getTime(array[index][startTimeKey], direction);
            array[index][startTimeKey] = changed;
            data[index].start_time = changed;
        } else {
            const changed = getTime(array[index][endTimeKey], direction);
            array[index][endTimeKey] = changed;
            data[index].end_time = changed;
        }

        setValues({ ...values, playList: array });
        setVideoData({ ...videoData, tagList: data });
    };

    const changeGameTime = (array, idx) => {
        setGameTime({
            ...gameTime,
            period: getPeriod(array[idx].period),
            time: array[idx].time_in_game,
            home_team_goals: array[idx].home_team_goals ?? undefined,
            away_team_goals: array[idx].away_team_goals ?? undefined,
            home_team_image: game.home_team_image ?? undefined,
            away_team_image: game.away_team_image ?? undefined
        });
    };

    const getPlayTagList = async (func) => {
        func.then(async (res) => {
            setLoading(false);
            setLoadData(false);

            // Goal clips are shots only; assists are also tagged result=Goal, so filter them out.
            if (TagToActionData[tagIndex] === 'Goal') res = res.filter(isGoalTag);

            if (values.clickEventName === 'render') {
                setShowAlert(true);
                const result = await gameCreateCommand(res, (t(tagIndex) || tagIndex), [game], [game.id]);

                setShowResultAlert(true);
                setDownState(result);
            } else if (values.clickEventName === 'sportcode') {
                setPlayerTagList(normalizeTagData(res));
                setExportHudl(true);
            } else if (values.clickEventName === 'my_edits') {
                setExportList(normalizeTagData(res));
                setExportEditOpen(true);
            } else {
                const normalizedRes = normalizeTagData(res);
                setVideoData({
                    ...videoData,
                    idx: 0,
                    tagList: normalizedRes.map((item) => {
                        return {
                            start_time: item.team_tag_start_time || item.player_tag_start_time,
                            end_time: item.team_tag_end_time || item.player_tag_end_time,
                            name: `${item.player_names} - ${item.action_names} - ${item.action_type_names} - ${item.action_result_names}`,
                            period: item.period,
                            time_in_game: item.time_in_game,
                            home_team_goals: item.home_team_goals,
                            away_team_goals: item.away_team_goals,
                            home_team_logo: item.home_team_logo,
                            away_team_logo: item.away_team_logo
                        };
                    })
                });
                setValues({ ...values, playList: normalizedRes });
                setCheckArray([]);
                res.map((item, index) => {
                    setCheckArray((oldRows) => [...oldRows, false]);
                });

                if (res.length > 0) {
                    changeGameTime(res, 0);
                    setCurTeamTagIdx(0);
                    setVideoPlayerOpen(true);
                } else {
                    setDownState(t('No clips found for this action'));
                    setShowResultAlert(true);
                }
            }
        }).catch((error) => {
            console.error('Error loading game data:', error);
            setLoading(false);
            setLoadData(false);
        });
    };

    useEffect(() => {
        // Only make API calls when teamId is valid (not -1)
        if (loadData && values.teamId > 0) {
            setLoading(true);
            setValues({ ...values, playList: [] });
            setVideoData({ ...videoData, tagList: [] });

            // Check if tag has ActionData mapping - use unified getGamePlayerTags/getOpponentTags
            const actionKey = TagToActionData[tagIndex];
            if (actionKey && ActionData[actionKey]) {
                const actionData = ActionData[actionKey];
                const teamId = values.isOur ? values.teamId : values.opponentTeamId;
                const useOrLogic = actionData.useOrLogic ? 1 : null;

                if (tagSide ? tagSide === 'our' : values.isOur) {
                    getPlayTagList(
                        GameService.getGamePlayerTags(
                            currentUser.id,
                            teamId,
                            null, // all players
                            `${game.id}`,
                            actionData.action_id,
                            actionData.action_type_id,
                            actionData.action_result_id,
                            null, null, null, null, null,
                            useOrLogic
                        )
                    );
                } else {
                    getPlayTagList(
                        GameService.getOpponentTags(
                            currentUser.id,
                            values.teamId, // our team id for opponent query
                            null, // all players
                            `${game.id}`,
                            actionData.action_id,
                            actionData.action_type_id,
                            actionData.action_result_id,
                            null, null, null, null, null
                        )
                    );
                }
            }
            // Buttons served by the generic /game/tagclips endpoint. Must come before the
            // per-button branches below, which are the endpoints they replace.
            else if (TAG_KEYS[tagIndex]) {
                getPlayTagList(GameService.getTagClips(TAG_KEYS[tagIndex], values.teamId, `${game.id}`, tagSide ? tagSide === 'our' : values.isOur));
            }
            // Complex possession-based tags - use old s4u_new_ functions
            else if (tagIndex === 'Game Highlight') {
                getPlayTagList(GameService.getGameHighlight(values.isOur ? values.teamId : values.opponentTeamId, `${game.id}`));
            } else if (tagIndex === 'Clean Game') {
                getPlayTagList(GameService.getCleanGame(values.isOur ? values.teamId : values.opponentTeamId, `${game.id}`));
            } else if (tagIndex === 'All Offensive Possessions') {
                if (values.isOur) getPlayTagList(GameService.getTeamOffensivePossession(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentOffensivePossession(values.teamId, `${game.id}`));
            } else if (tagIndex === 'All Defensive Possessions') {
                if (values.isOur) getPlayTagList(GameService.getTeamDefensivePossession(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentDefensivePossession(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Build Up Goalkeeper') {
                if (values.isOur) getPlayTagList(GameService.getTeamBuildupGoalkeeper(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentBuildupGoalkeeper(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Build Up Own Half') {
                if (values.isOur) getPlayTagList(GameService.getTeamBuildonDefensiveHalf(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentBuildonDefensiveHalf(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Build Up Opponent Half') {
                if (values.isOur) getPlayTagList(GameService.getTeamBuildOnOffensiveHalf(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentBuildOnOffensiveHalf(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Started From Goalkeeper') {
                if (values.isOur) getPlayTagList(GameService.getTeamBuildupGoalkeeperKick(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentBuildupGoalkeeperKick(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Counter-Attacks') {
                if (values.isOur) getPlayTagList(GameService.getTeamCounterAttack(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentCounterAttack(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Started From Interception') {
                if (values.isOur) getPlayTagList(GameService.getTeamInterception(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentInterception(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Started From Tackle') {
                if (values.isOur) getPlayTagList(GameService.getTeamTackle(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentTackle(values.teamId, `${game.id}`));
            } else if (tagIndex === 'Started From Throw In') {
                if (values.isOur) getPlayTagList(GameService.getTeamThrowIn(values.teamId, `${game.id}`));
                else getPlayTagList(GameService.getOpponentThrowIn(values.teamId, `${game.id}`));
            } else {
                // Unknown tag
                setLoading(false);
                setLoadData(false);
                window.alert('This action type is not available yet.');
            }
        }
    }, [tagIndex, loadData, values.teamId]);

    useEffect(() => {
        (async () => {
            setLoading(true);
            await GameService.getAllMyCoachTeam().then((res) => {
                const filtered = res.filter(
                    (item) => item.season_name === game.season_name && item.league_name === game.league_name && (item.team_id === game.home_team_id || item.team_id === game.away_team_id)
                );
                const team = filtered[0].team_id;
                const opponent = team === game.home_team_id ? game.away_team_id : game.home_team_id;

                setValues({ ...values, teamId: team, opponentTeamId: opponent });
                setGameTime({ ...gameTime, video_url: game.video_url });
                setLoading(false);
            });
        })();
    }, []);

    useEffect(() => {
        setCheckArray([]);
        values.playList.map((item, index) => {
            setCheckArray((oldRows) => [...oldRows, values.selectAll]);
        });
    }, [values.selectAll]);

    useEffect(() => {
        if (values.playList.length > 0) changeGameTime(values.playList, curTeamTagIdx);
    }, [curTeamTagIdx]);

    return (
        <Box sx={{ width: '100%', background: '#f8fafc', minHeight: '78vh', overflowY: 'auto', padding: '12px 8px' }}>
                        {showAlert && <Alert text={'Render started!'} />}
            {showResultAlert && <Alert text={downState} />}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <GameTagButtonList
                    t={t}
                    selectedTag={tagLabel}
                    onShow={handleShowPopover}
                    isTeams={false}
                    loadingTag={loading ? tagIndex : null}
                />
                <GameTagMenu
                    t={t}
                    anchor={menuAnchorEl}
                    onClose={() => setMenuAnchorEl(null)}
                    onView={handleClickView}
                    onHudl={handleClickHudlFromMenu}
                    onRender={handleClickRenderFromMenu}
                    onEdits={handleClickEditFromMenu}
                />
            </Box>
            <SharedVideoPlayer
                t={t}
                tagName={tagLabel}
                open={videoPlayerOpen}
                onClose={() => setVideoPlayerOpen(false)}
                video_url={gameTime.video_url}
                tagList={videoData.tagList.map((item, index) => ({
                    ...item,
                    ...values.playList[index],
                    player_names: values.playList[index]?.player_names,
                    action_names: values.playList[index]?.action_names,
                    action_type_names: values.playList[index]?.action_type_names,
                    action_result_names: values.playList[index]?.action_result_names
                }))}
                showEditDialog={false}
            />
            {exportHudl && <XmlDataFilterGame game={game} tagList={playerTagList} isOur={tagSide ? tagSide === 'our' : values.isOur} tag_name={(t(tagIndex) || tagIndex)} setExportXML={setExportHudl} />}
            <GameExportToEdits t={t} open={exportEditOpen} onClose={() => setExportEditOpen(false)} tagList={exportList} isTeams={true} />
        </Box>
    );
};

export default GameOverview;
